<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <v-toolbar color="white" dark elevation="2">
              <v-toolbar-title color="primary">
                <v-img
                  alt="Dutch Bros"
                  class="shrink mr-2"
                  contain
                  src="https://files.dutchbros.com/logos/primary_logo_blue_text.png"
                  transition="scale-transition"
                  width="120"
                />
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-title
                class="text-subtitle-1 font-weight-bold"
                style="color: #006098"
                >Broista @ {{ company.location }}</v-toolbar-title
              >
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-card-title
                      >Broista @ {{ company.location }}</v-card-title
                    >
                    <div class="pl-4">
                      Fill out this 30 second form to receive hiring updates for
                      the part-time BROISTA position in
                      <u
                        class="text-decoration-none font-weight-bold"
                        style="color: #006098"
                        >{{ company.location }}</u
                      >.
                      <div>
                        It's fun to work in a company where people truly believe
                        in what they are doing. At Dutch Bros Coffee, we are
                        more
                      </div>
                      <div>
                        than just a coffee company. We are a fun-loving,
                        mind-blowing company that makes a difference one cup at
                        a time.
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <div class="pl-4">
                      <div>
                        The part time Broista position is primarily responsible
                        for the creation of Dutch Bros drinks while following
                        the set guidelines and vision of the company.
                      </div>
                      <div>
                        Providing excellent customer service at all times,
                        proving that we are a People company serving coffee not
                        a Coffee company, serving people.
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="firstName"
                      :rules="nameRules"
                      label="First name"
                      prepend-inner-icon="person"
                      required
                      filled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="lastName"
                      :rules="nameRules"
                      label="Last name"
                      prepend-inner-icon="person"
                      required
                      filled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      prepend-inner-icon="email"
                      required
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="phone"
                      v-model="phone"
                      :rules="phoneRules"
                      label="Phone Number"
                      prepend-inner-icon="phone_iphone"
                      v-mask="'(###)###-####'"
                      required
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-checkbox
                      :rules="required"
                      style="margin-top: 0 !important"
                    >
                      <template slot="label">
                        <div
                          style="width: 100%"
                          class="d-block text-subtitle-2"
                        >
                          <div class="d-inline d-sm-block d-xs-block">
                            I agree to Dutch Bros
                            <a
                              class="text-decoration-none"
                              @click.stop
                              target="_blank"
                              href="https://www.dutchbros.com/underline-text-of-service/"
                              >Terms of Service,</a
                            >
                            &nbsp;<a
                              class="text-decoration-none"
                              @click.stop
                              target="_blank"
                              href="https://www.dutchbros.com/privacy-rights-notice"
                              >Privacy Rights Notice,</a
                            >
                            &nbsp;<a
                              class="text-decoration-none"
                              @click.stop
                              target="_blank"
                              href="/apply/employment-notices"
                              >Employment Notices.</a
                            >
                          </div>
                          <!-- <div class="d-inline">
                            &nbsp;<a
                              class="underline-text"
                              @click.stop
                              target="_blank"
                              href="/apply/privacy-rights-notice"
                              >Privacy Rights Notice</a
                            >, and
                          </div> -->
                          <!-- <div class="d-inline">
                            &nbsp;<a
                              class="underline-text"
                              @click.stop
                              target="_blank"
                              href="/apply/employment-notices"
                              >Employment Notices</a
                            >.
                          </div> -->
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col class="text-center mb-5" cols="12" md="12">
                    <v-btn right ripple color="primary" @click="formSubmit"
                      >Let's Do This!</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import FooterBar from "../components/Footer";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RC_SITE_KEY });

export default {
  components: { FooterBar },

  computed: {
    firstName: {
      get() {
        return this.$store.state.firstName;
      },
      set(value) {
        this.$store.commit("setFirstName", { firstName: value });
      },
    },
    lastName: {
      get() {
        return this.$store.state.lastName;
      },
      set(value) {
        this.$store.commit("setLastName", { lastName: value });
      },
    },
    email: {
      get() {
        return this.$store.state.email;
      },
      set(value) {
        this.$store.commit("setEmail", { email: value });
      },
    },
    phone: {
      get() {
        return this.$store.state.phone;
      },
      set(value) {
        this.$store.commit("setPhone", { phone: value });
      },
    },
    company: {
      get() {
        return this.$store.state.company;
      },
      set(value) {
        this.$store.commit("setCompany", { company: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
    locations: {
      get() {
        return this.$store.state.locations;
      },
      set(value) {
        this.$store.commit("setLocations", { locations: value });
      },
    },
  },

  data: () => ({
    valid: false,
    loading: true,
    required: [(v) => !!v || "This is required"],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 50 || "Name must be less than 50 characters",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v) ||
        "E-mail must be valid",
    ],
    phoneRules: [
      (v) => !!v || "Phone is required",
      (v) =>
        /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(
          v
        ) || "Phone must be valid",
    ],
  }),
  props: {
    source: String,
  },

  methods: {
    async formSubmit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        const token = await this.getRecaptchaToken("leadForm");
        let currentObj = this;
        axios
          .post(
            process.env.VUE_APP_LEAD_API + `?rc=${token}`,
            this.$store.state
          )
          .then((response) => {
            currentObj.output = response.data;
            this.$router.push({ name: "Success" });
          })
          .catch((error) => {
            console.log("There was an error:", error.response);
            currentObj.output = error;
          });
      }
    },
    async getCompany() {
      this.loading = true;
      const token = await this.getRecaptchaToken("getCompany");
      axios
        .get(
          process.env.VUE_APP_COMPANY_API +
            this.$route.params.location +
            `?rc=${token}`
        )
        .then((response) => {
          this.company = response.data.company;
          this.company.location = `${response.data.company.hiring_company_name}, ${response.data.company.state}`;
          this.locations = [this.$route.params.location];
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
          this.$router.push({ name: "Home" });
        });
      this.loading = false;
    },
    async getRecaptchaToken(action) {
      await this.$recaptchaLoaded();
      return await this.$recaptcha(action);
    },
  },

  async created() {
    await this.getCompany();
  },

  /* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }*/
};
</script>
<style>
.job-description {
  padding-bottom: 0;
}
.job-description-title {
  padding-bottom: 0;
  color: #006098 !important;
  font-weight: 700;
}
</style>
